module.exports = __webpack_public_path__ + "assets/28f6b24a4b5dfe4d9564be6e06a15cb7.png";